type RateLimitType = "anonymous" | "authenticated";
type Listener = (type: RateLimitType) => void;

let isActive = false;
const listeners = new Set<Listener>();

export const rateLimitEvents = {
  emit(type: RateLimitType): void {
    if (isActive) return;
    isActive = true;
    listeners.forEach((listener) => listener(type));
  },

  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  reset(): void {
    isActive = false;
  },

  get isActive(): boolean {
    return isActive;
  },
};
